import { booleanAttribute, Component, Input } from '@angular/core';
import { EskPopoverDirective } from '../../../../../directives/esk-popover.directive';
import { PineEconomicAnalysisToolPopover } from '../data-acces/pine-economic-analysis-popover';
import { key } from 'localforage';

@Component({
  selector: 'app-pine-popover',
  imports: [EskPopoverDirective],
  templateUrl: './pine-popover.component.html',
  standalone: true,
  styleUrl: './pine-popover.component.css'
})
export class PinePopoverComponent {
  @Input({ transform: booleanAttribute }) showLabel: boolean = true;
  @Input({ transform: booleanAttribute }) showInfo: boolean = true;
  @Input({ transform: booleanAttribute }) showDollarInfo: boolean = false;
  @Input() labelFor: string = '';
  @Input() labelText: string = '';
  @Input() infoPopoverKey: string = '';
  @Input() dollarPopoverKey: string = '';
  @Input() defaultValue: string = '';

  protected readonly PineEconomicAnalysisToolPopover =
    PineEconomicAnalysisToolPopover;
  protected readonly key = key;

  get dollarPopoverKeyVal() {
    const dollarVal =
      PineEconomicAnalysisToolPopover.DOLLAR_POPOVER_CONTENT[
        this.dollarPopoverKey
      ];

    if (dollarVal.includes('{0}')) {
      return dollarVal.replace('{0}', this.defaultValue);
    }
    return dollarVal;
  }

  get infoPopoverKeyVal() {
    return PineEconomicAnalysisToolPopover.INFO_POPOVER_CONTENT[
      this.infoPopoverKey
    ];
  }
}
